import { SkeletonBox } from '@circlefin/components'
import { createFormInput } from '@circlefin/form/Form.Input'
import classNames from 'classnames'
import useTranslation from 'next-translate/useTranslation'

export interface DateProps {
  /**
   * Loading?
   */
  loading?: boolean
  /**
   * Disabled?
   */
  disabled?: boolean
  /**
   * Warning?
   */
  warning?: boolean
  /**
   * Label.
   */
  label?: string
  /**
   * Placeholder.
   */
  placeholder?: string
  /**
   * Custom name?
   */
  name?: string
  /**
   * Custom Style?
   */
  className?: string
}

const Input = createFormInput()

export const Date: React.FC<DateProps> = ({
  loading = false,
  name = 'date',
  disabled,
  warning,
  className,
  label,
  placeholder,
}) => {
  const { t } = useTranslation('forms')

  return (
    <SkeletonBox
      className={classNames('mt-6 h-10', className)}
      loading={loading}
    >
      <Input
        className={classNames('w-full', className)}
        disabled={disabled}
        label={label ?? t`input.common.date.label`}
        mask="date"
        name={name}
        placeholder={placeholder ?? t`input.common.date.placeholder`}
        warning={warning}
      />
    </SkeletonBox>
  )
}
